<template>
  <el-dialog
    title="选择社群"
    :visible.sync="showDialog"
    :before-close="cancelAction"
    width="1025px"
  >
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">群管理员姓名</span>
        <el-input
          v-model="params.salesperson_name"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">群ID</span>
        <el-input
          v-model="params.chat_id"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="listData"
      tooltip-effect="dark"
      :row-key="getRowKeys"
      @select="handleSelectionChange"
      @select-all="selectAll"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="50"
      />
      <el-table-column
        prop="chat_id"
        label="群ID"
      />
      <el-table-column
        prop="owner"
        label="群管理员"
      />
    </el-table>

    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.pageSize"
          @current-change="handleCurrentChange"
        />
      </div>
      <div>
        <span class="m-r-6">已选中{{ selectCount }}个群</span>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="saveAction"
        >
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getCommunityList } from '@/api/component'
export default {
  name: 'SpCommunitySelect',
  model: {
    prop: 'showDialog',
    event: 'showDialogChange'
  },
  props: {
    showDialog: {
      // 展示模态框
      type: Boolean,
      default: false
    },
    selectData: {
      // 已勾选的列表数据
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      key: 1,
      listData: [],
      total_count: 0,
      loading: false,
      params: {
        page: 1,
        pageSize: 10,
        salesperson_name: '',
        chat_id: ''
      },
      multipleSelection: [],
      submitLoading: false,

      selectCount: 0,
      firstShow: false
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        this.firstShow = true
        this.selectCount = this.selectData ? this.selectData.length : 0
        this.getList()
      }
    }
  },
  methods: {
    // 换页可选择
    getRowKeys (row) {
      return row.id
    },

    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('showDialogChange', false)

      // 如果不需要默认勾选则关闭取消
      if (!this.selectData) {
        this.multipleSelection = []
        this.selectCount = 0
        this.$refs.multipleTable.clearSelection()
      }
    },
    async getList () {
      this.loading = true
      const data = await getCommunityList(this.params)
      if (data) {
        this.listData = data.list
        this.total_count = data.total_count
        this.loading = false

        // 获取选中元素 可传数组对象，也可传数组id
        if (this.firstShow) {
          this.firstShow = false
          this.toggleSelection(this.selectData)
        }
      }
    },
    // 查询
    searchList () {
      this.params.page = 1
      this.getList()
    },
    // 全选事件
    selectAll (val) {
      this.multipleSelection = val
      this.selectCount = val.length
    },
    // table表格选择
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.selectCount = val.length
    },
    saveAction () {
      // 保存选中的Ids
      let communityIds = []
      this.multipleSelection.forEach((v) => {
        communityIds = communityIds.concat(v.id)
      })
      this.$emit('chooseCommunity', this.multipleSelection, communityIds.join(','))
    },
    toggleSelection (rows) {
      if (rows && rows.length > 0) {
        rows.forEach((row) => {
          if (row.card_id) {
            this.$refs.multipleTable.toggleRowSelection(row, true)
          } else {
            let newrow = { card_id: row }
            this.$refs.multipleTable.toggleRowSelection(newrow, true)
          }
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.select {
  width: 116px;
}
</style>
